

import { defineComponent} from 'vue';

export default defineComponent({
    name: 'skeletoncrudtabla',
    setup() {
        
        return {
            
        };
    },
});
